import React, {Component} from 'react';
import Relay from 'react-relay';

export default class Navbar extends Component{

	constructor(props)
	{
		super(props);
		// this.logout=this.navigate.bind(this);
	}

	static propTypes = {
	    children: React.PropTypes.node.isRequired
	};

	logout() {
	    var cookies = document.cookie.split(";");

	    for (var i = 0; i < cookies.length; i++) {
	    	var cookie = cookies[i];
	    	var eqPos = cookie.indexOf("=");
	    	var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
	    	document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
	    }
		
		// var url = window.location.href;
		window.history.go(-window.history.length);
		// window.location.href = url;
		window.location.href = "/#/login";
	}

	onNewTodoSave = (text) => {};
	render(){
		const { children } = this.props;

		var padding5={
			padding:5,
			height:50,
			width:50
		}

		var padding20={
			padding:20
		}

		var brandStyle={
			fontSize:24,
			letterSpacing:0.4,
			color:'black'
		}
		// TODO this is not working, find some fix.
		var navbarStyle={
			backgroundColor:'white',
			border: 'solid 0.5px #d8d8d8'
		}

		var styleHidden={
			display:'none'
		}

		var searchInputStyle={
			paddingTop: 6,
			paddingRight: 40,
			paddingBottom: 6,
			paddingLeft: 15,
			margin:3,
			background: 'url("https://dndw32r4edmw5.cloudfront.net/search_icon.png") no-repeat',
			backgroundPosition:'97% 98%', //x pos and y pos
			borderRadius:100,
			MozBorderRadius:100,
			WebkitBorderRadius:100,
			/*
			'border-radius':15,
			'-moz-border-radius':15,
			'-webkit-border-radius':15,
			*/
		};



		return(
			<div>
				<nav role="navigation" className="navbar navbar-default" style={navbarStyle}>
					<div className="navbar-header">
	            		<button type="button" data-target="#navbarCollapse" data-toggle="collapse" className="navbar-toggle">
	                		<span className="sr-only">Toggle navigation</span>
	                		<span className="icon-bar"></span>
	                		<span className="icon-bar"></span>
	                		<span className="icon-bar"></span>
	            		</button>
	            		<a className="navbar-brand" style={brandStyle}>Survey<b>mate</b></a>
	        		</div>
				</nav>
				<div data-framework="relay">
	          		{children}
	      		</div>
			</div>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/components/navbarLogin.js
 **/